import { SEO } from "@/components/SEO";
import { Link } from "wouter";

export default function About() {
    return (
        <div className="min-h-screen bg-background text-foreground pb-12">
            <SEO
                title="About Us - Ganjidrinks | Traditional Indian Ragi Beverage Startup | Healthy Drinks Brand"
                description="Founded in 2026, Ganjidrinks is an Indian beverage startup reviving traditional ragi (finger millet) drinks. Affordable, convenient, and satisfying — real nutrition at ₹25 in Bangalore."
                keywords="ganji drinks, about ganjidrinks, beverage startup, indian startup, ragi drink brand, healthy drinks company, millet drink brand, traditional Indian beverage company, Bangalore startup, ragi malt brand, healthy beverage startup India"
            />

            {/* Empty Header / Spacer */}
            <nav className="p-4 md:p-6 h-20 pointer-events-none sticky top-0 z-40 bg-transparent"></nav>

            <main className="container mx-auto px-4 pt-8 md:pt-12 max-w-3xl text-center">
                {/* Back Button */}
                <div className="mb-8 text-left">
                    <Link href="/">
                        <a className="inline-flex items-center gap-2 hover:opacity-75 transition-opacity"
                            style={{ color: 'hsl(var(--ganji-rustic-brown))' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5" />
                                <path d="M12 19l-7-7 7-7" />
                            </svg>
                            <span className="text-lg" style={{ fontFamily: "'Patrick Hand', cursive" }}>Back</span>
                        </a>
                    </Link>
                </div>

                <h1
                    className="text-4xl md:text-6xl mb-8"
                    style={{ fontFamily: "'Permanent Marker', cursive", color: 'hsl(var(--ganji-rustic-brown))' }}
                >
                    About Ganjidrinks
                </h1>

                <div className="space-y-8 text-lg md:text-xl leading-relaxed opacity-90" style={{ color: 'hsl(var(--ganji-rustic-brown))' }}>
                    <p>
                        <strong className="block text-2xl mb-4 font-normal" style={{ fontFamily: "'Patrick Hand', cursive" }}>
                            Founded in 2026, Ganjidrinks is an Indian beverage brand on a mission to revive tradition.
                        </strong>
                    </p>

                    <p>
                        We believe that the best energy comes from our roots. Ganji, a traditional ragi-based drink, has been a staple in Indian households for generations. It represents strength, health, and the warmth of home.
                    </p>

                    <p>
                        Our vision is simple: To make this heritage superfood accessible to everyone, everywhere. No preservatives, no artificial nonsense—just pure, honest nutrition in a bottle.
                    </p>

                    <div className="py-8">
                        <img
                            src="/images/Gemini_Generated_Image_bzang6bzang6bzan.png"
                            alt="Ganji drinks bottles"
                            className="rounded-xl shadow-xl mx-auto w-full max-w-lg"
                        />
                    </div>

                    <p>
                        From the fields of our farmers to your hands, every bottle of Ganjidrinks carries the legacy of our ancestors and the promise of a healthier future.
                    </p>
                </div>
            </main>
        </div>
    );
}
